module.exports = __webpack_public_path__ + "img/ruach_no.e99df32f.png";